/* eslint-disable max-len */
import { API } from '@/redux/config/index';
import { toast } from 'react-toastify';
import { StnAPI } from '../config/customHeadersApi';
import {
  getAllServicesStart,
  getServiceByIdStart,
  setAddCompanyServiceModalToggle,
  setAddServiceModalToggle,
  setAddServiceToCustomer,
  setAllcustomerServiceReport,
  setAllServices,
  setAllServicesOfCustomer,
  setCreateService,
  setCreateServiceModalToggle,
  setCustomerService,
  setDeleteCustomerService,
  setDeleteService,
  setEditCompanyServiceModalToggle,
  setEditServiceModalToggle,
  setReducerError,
  setService,
  setStyleGuideServiceModalToggle,
  setUpdateCustomerService,
  setUpdateService,
  start,
} from '../reducers/servicesReducer';
import { raiseErrorException } from '../../utils/raiseErrorException';

export const toggleCreateServiceModal = (state) => async (dispatch) => {
  dispatch(setCreateServiceModalToggle(state));
};
export const toggleEditServiceModal = (state) => async (dispatch) => {
  dispatch(setEditServiceModalToggle(state));
};

export const toggleAddCompanyServiceModal = (state) => async (dispatch) => {
  dispatch(setAddCompanyServiceModalToggle(state));
};
export const toggleEditCompanyServiceModal = (state) => async (dispatch) => {
  dispatch(setEditCompanyServiceModalToggle(state));
};
export const toggleStyleGuideServiceModal = (state) => async (dispatch) => {
  dispatch(setStyleGuideServiceModalToggle(state));
};

// Get ALL services
export const getAllServices = () => async (dispatch) => {
  try {
    dispatch(getAllServicesStart());
    const response = await API.get('/services/');

    return dispatch(setAllServices(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Create a New Service
export const createService =
  (abbrev, service, shortDescription, frequency, engineerID, hours, description, toggle) => async (dispatch) => {
    try {
      dispatch(start());
      const response = await API.post('/services', {
        abbrev,
        service,
        shortDescription,
        frequency,
        engineerID,
        hours,
        description,
      });

      dispatch(setCreateService(response?.data));
      toggle();
      dispatch(getAllServices());
      return toast.success('Service Created Successfully');
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError, 'post');
    }
  };

// Get service with ID
export const getServiceByID = (serviceID) => async (dispatch) => {
  try {
    dispatch(getServiceByIdStart());
    const response = await API.get(`/services/${serviceID}`);

    return dispatch(setService(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Update service with ID
export const updateService =
  (serviceID, abbrev, service, shortDescription, engineer, frequency, hours, description, toggle) =>
  async (dispatch) => {
    try {
      dispatch(start());
      const response = await API.put(`/services/${serviceID}`, {
        abbrev,
        service,
        shortDescription,
        engineerID: engineer,
        frequency,
        hours,
        description,
      });

      dispatch(setUpdateService(response?.data));
      toggle();
      dispatch(getServiceByID(serviceID));
      dispatch(getAllServices());
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError, 'put');
    }
  };

// Delete service with ID
export const deleteService = (serviceID, toggle) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.delete(`/services/${serviceID}`);

    dispatch(setDeleteService(response?.data));
    toggle();
    dispatch(getAllServices());
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'delete');
  }
};

// Get Services report for all customers
export const getServicesReportForAllCustomers = () => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get('/services/customer/all');

    return dispatch(setAllcustomerServiceReport(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Get all services of customer
export const getAllServicesOfCustomer = (customerID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/services/customer`);
    console.log('response', response);

    return dispatch(setAllServicesOfCustomer(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Get Customer Service by ID
export const getCustomerServiceByID = (customerID, siteID, serviceID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await StnAPI.get(`/services/customer/service/${serviceID}`, {
      headers: {
        'x-customer-id': customerID,
        'x-site-id': siteID,
      },
    });

    return dispatch(setCustomerService(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Add service to Customer
export const addServiceToCustomer = (customerID, siteID, serviceID, toggle) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await StnAPI.post(
      `/services/customer`,
      {
        serviceID,
      },
      {
        headers: {
          'x-customer-id': customerID,
          'x-site-id': siteID,
        },
      },
    );

    dispatch(setAddServiceToCustomer(response?.data));
    dispatch(getCustomerServiceByID(customerID, siteID, response?.data?.id));
    dispatch(getAllServicesOfCustomer(customerID));
    toggle();
    dispatch(toggleEditCompanyServiceModal());
    toast.success('Service added successfully');
    dispatch(setAddServiceModalToggle());
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'post');
  }
};

// Update Customer Service
export const addedCustomerService =
  (customerID, siteID, serviceID, devices, frequency, specialinstructions, defaultProjectKey) => async (dispatch) => {
    try {
      dispatch(start());
      const response = await StnAPI.patch(
        `/services/customer/service/${serviceID}`,
        {
          devices,
          defaultProjectKey,
          frequency,
          specialinstructions,
        },
        {
          headers: {
            'x-customer-id': customerID,
            'x-site-id': siteID,
          },
        },
      );
      // dispatch(setUpdateCustomerService(response?.data))
      // dispatch(setAddServiceModalToggle())
      toast.success('Company Service updated successfully');
      dispatch(getAllServicesOfCustomer(customerID));
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError, 'patch');
    }
  };

export const toggleServiceModal = () => async (dispatch) => {
  dispatch(setAddServiceModalToggle());
};
export const updateCustomerService =
  (customerID, siteID, serviceID, devices, frequency, specialinstructions, defaultProjectKey, toggle) =>
  async (dispatch) => {
    try {
      dispatch(start());
      const response = await StnAPI.patch(
        `/services/customer/service/${serviceID}`,
        {
          devices,
          defaultProjectKey,
          frequency,
          specialinstructions,
        },
        {
          headers: {
            'x-customer-id': customerID,
            'x-site-id': siteID,
          },
        },
      );

      dispatch(setUpdateCustomerService(response?.data));
      if (!toggle) {
        console.log('____s');
        dispatch(setAddServiceModalToggle());
      } else {
        toggle();
      }
      toast.success('Company Service updated successfully');
      dispatch(getAllServicesOfCustomer(customerID));
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError, 'patch');
    }
  };

// Delete Customer Service
export const deleteCustomerService = (customerID, siteID, serviceID, toggle) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await StnAPI.delete(`/services/customer/service/${serviceID}`, {
      headers: {
        'x-customer-id': customerID,
        'x-site-id': siteID,
      },
    });

    dispatch(setDeleteCustomerService(response?.data));
    toggle();
    dispatch(getAllServicesOfCustomer(customerID));
    toast.success('Company Service deleted successfully');
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'delete');
  }
};
